import { ExportDocumentFormat } from "types/enums/ExportDocumentFormat.enum";

export const useGenerateGradedFileName = (
  submittedDocument: SubmittedDocument,
  exportFormat: ExportDocumentFormat
) => {
  if (exportFormat == ExportDocumentFormat.docx) {
    var docName = submittedDocument!.name;
    docName = docName.replace(".docx", "");
    docName = `${docName}_graded.docx`;

    return docName;
  }

  if (exportFormat == ExportDocumentFormat.pdf) {
    var docName = submittedDocument!.name;
    docName = docName.replace(".pdf", "");
    docName = `${docName}_graded.pdf`;

    return docName;
  }

  return submittedDocument!.name;
};
